/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { OperationalLogger } from "./OperationalLogger";
import { LoggingWindow } from "./LoggingWindow";
import { LOG_CONTROL_STATUS_EVENT } from "./LogControlStatusConstants";
import type { LogDetails } from "../types";

export type TLoggingConfigSnapshot = {
  readonly analyticsEnabled: boolean;

  readonly diagnosticBlacklistSize: number;

  readonly diagnosticBlacklistVersion?: string;

  readonly diagnosticBudgetBytes: number;

  readonly diagnosticBudgetPeriodSec: number;

  readonly diagnosticEnabled: boolean;

  readonly diagnosticLevel: string;

  readonly diagnosticWindow: LoggingWindow | null;

  readonly operationalBudgetBytes: number;

  readonly operationalBudgetPeriodSec: number;

  readonly serviceApiEnabled: boolean;

  readonly serviceApiWindow: LoggingWindow | null;

  readonly whinyEnabled: boolean;

  readonly whinyWindow: LoggingWindow | null;
};

const addWindowFields = (
  fields: LogDetails,
  window: LoggingWindow | null,
  fieldPrefix: string
): void => {
  if (window === null || window.getEndEpochSec() <= window.getStartEpochSec()) {
    return;
  }

  fields[`${fieldPrefix}Start`] = String(window.getStartEpochSec());
  fields[`${fieldPrefix}End`] = String(window.getEndEpochSec());
};

export const emitLogControlStatus = (
  snapshot: TLoggingConfigSnapshot
): void => {
  const fields: LogDetails = {
    diagnosticLoggingEnabled: String(snapshot.diagnosticEnabled),
    diagnosticLogLevel: snapshot.diagnosticLevel,
    diagnosticBudgetBytes: String(snapshot.diagnosticBudgetBytes),
    diagnosticBudgetPeriodSec: String(snapshot.diagnosticBudgetPeriodSec),
    diagnosticBlacklistSize: String(snapshot.diagnosticBlacklistSize),
    operationalBudgetBytes: String(snapshot.operationalBudgetBytes),
    operationalBudgetPeriodSec: String(snapshot.operationalBudgetPeriodSec),
    whinyEnabled: String(snapshot.whinyEnabled),
    serviceAPILoggingEnabled: String(snapshot.serviceApiEnabled),
    analyticsLoggingEnabled: String(snapshot.analyticsEnabled)
  };

  if (
    snapshot.diagnosticBlacklistVersion !== undefined &&
    snapshot.diagnosticBlacklistVersion.length > 0
  ) {
    fields.diagnosticBlacklistVersion = snapshot.diagnosticBlacklistVersion;
  }

  addWindowFields(fields, snapshot.diagnosticWindow, "loggingWindow");
  addWindowFields(fields, snapshot.whinyWindow, "whinyWindow");
  addWindowFields(fields, snapshot.serviceApiWindow, "serviceAPIWindow");

  OperationalLogger.logEvent(LOG_CONTROL_STATUS_EVENT, fields);
};
